import { combineReducers } from 'redux';
import { cart } from './Reducers/Cart.reducer';
import { quickSearch } from './Reducers/QuickSearch.reducer';
import { organizationSearch } from './Reducers/OrganizationSearch.reducer';
import { navigation } from './Reducers/Navigation.reducer';
import { facetedSearch } from './Reducers/FacetedSearch.reducer';
import { myPage } from './Reducers/MyPage.reducer';
import { checkout } from './Reducers/Checkout.reducer';
import { lightboxImages } from './Reducers/LightboxImages.reducer';
import { comparison } from './Reducers/Comparison.reducer';
import { wishlist } from './Reducers/WishList.reducer';
import { notification } from './Reducers/Notification.reducer';

const app = combineReducers({
    cart,
    checkout,
    quickSearch,
    navigation,
    myPage,
    facetedSearch,
    lightboxImages,
    comparison,
    wishlist,
    notification,
    organizationSearch,
});

export default app;
